import { render, staticRenderFns } from "./GoalCurrentValueForm.vue?vue&type=template&id=0c43b897&scoped=true"
import script from "./GoalCurrentValueForm.vue?vue&type=script&lang=ts"
export * from "./GoalCurrentValueForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c43b897",
  null
  
)

export default component.exports